import React from 'react';

const Spacer = () => <div className="spacer layout" />;

export default Spacer;
